import { render, staticRenderFns } from "./skyCascaderPanels.vue?vue&type=template&id=10c2e956"
import script from "./skyCascaderPanels.vue?vue&type=script&lang=js"
export * from "./skyCascaderPanels.vue?vue&type=script&lang=js"
import style0 from "./skyCascaderPanels.vue?vue&type=style&index=0&id=10c2e956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports